import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo_final.png";

const RegisterConfirmation = () => {
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next");
  const loginHref = next ? `/login?next=${encodeURIComponent(next)}` : "/login";
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-8 md:p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-6">
          <img
            src={logo}
            alt="Nutrir Corpo & Mente"
            className="w-36 h-36 md:w-32 md:h-32 mx-auto mb-2 object-contain"
          />
        </div>

        <div className="bg-card rounded-2xl p-8 shadow-card border border-border text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-5">
            <MailCheck className="w-8 h-8 text-primary" />
          </div>

          <h2 className="text-2xl md:text-xl font-bold text-foreground mb-3">
            Verifique seu e-mail
          </h2>

          <p className="text-base md:text-sm text-muted-foreground mb-2 leading-relaxed">
            Enviamos um link de confirmação para o seu e-mail.
          </p>

          <p className="text-base md:text-sm text-muted-foreground mb-6 leading-relaxed">
            Clique no link recebido para ativar sua conta e ter acesso ao sistema.
          </p>

          <div className="rounded-xl bg-muted/50 border border-border p-4 mb-6 text-left space-y-2">
            <p className="text-sm font-medium text-foreground">📋 Próximos passos:</p>
            <ol className="list-decimal list-inside space-y-1.5 text-sm text-muted-foreground">
              <li>Abra sua caixa de entrada</li>
              <li>Procure o e-mail de <strong className="text-foreground">Nutrir Corpo &amp; Mente</strong></li>
              <li>Clique em <strong className="text-foreground">"Confirmar meu e-mail"</strong></li>
              <li>Você será redirecionado e poderá fazer login</li>
            </ol>
          </div>

          <p className="text-xs text-muted-foreground mb-5">
            Não encontrou o e-mail? Verifique também a pasta de <strong>spam</strong> ou lixo eletrônico.
          </p>

          <Button asChild variant="outline" className="w-full h-[52px] md:h-10 text-base md:text-sm">
            <Link to={loginHref}>Ir para o Login</Link>
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default RegisterConfirmation;
